import * as React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'

const Label = ({ labelTitle }) => {
  const bgImage = useStaticQuery(graphql`
    {
      file(name: { eq: "label_line" }) {
        publicURL
      }
    }
  `)
  return (
    <div
      css={css`
        position: relative;
        display: inline-block;
        &::before {
          content: '';
          position: absolute;
          width: 90%;
          height: 16px;
          background-color: #cee0e2;
          top: 60%;
          left: 24px;
          z-index: 1;
        }
        &::after {
          content: '';
          position: absolute;
          width: 60px;
          height: 16px;
          background-image: url(${bgImage.file.publicURL});
          top: 60%;
          right: -40px;
          z-index: 1;
        }
      `}
    >
      <h2 css={titleStyle}>{labelTitle}</h2>
    </div>
  )
}

Label.propTypes = {
  labelTitle: PropTypes.string
}

Label.defaultProps = {
  labelTitle: ``
}

const titleStyle = css`
  position: relative;
  font-size: 2.4rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1;
  z-index: 5;
`

export default Label
